import { defineMessages } from 'react-intl'

export default defineMessages({
  labelLoading: {
    id: 'app.components.LoadingIndicator.labelLoading',
    defaultMessage: 'Loading Indicator',
    description: 'Aria Label',
  },
})
